/** Validate UUID v4 format (8-4-4-4-12 hex). Server validates full semantics. */
export const isValidUuid = (value: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.trim());

/**
 * Generate a UUID v4.
 * Uses `crypto.randomUUID()` when available (browser / Node 16+).
 * Falls back to `Math.random()` in environments without Web Crypto (e.g., old jsdom).
 */
export const generateUuidV4 = (): string => {
  if (globalThis.crypto !== undefined && typeof globalThis.crypto.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/g, (character: string) => {
    const random = Math.floor(Math.random() * 16);
    const value = character === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};
